import { useCallback } from 'react'
import { AlmanacFile } from 'types'

import { usePostActionService, PostAction } from 'components/PostPreviewModalV2/hooks/usePostActionService'
import { usePostPreviewStore } from 'components/PostPreviewModalV2/PostPreviewStoreProvider'

export const usePostScheduleService = ({
  action,
  onComplete,
}: {
  action: PostAction.AutoSchedule | PostAction.Reminder
  onComplete?: (files: AlmanacFile[]) => void
}) => {
  const { run } = usePostActionService()
  const store = usePostPreviewStore()

  const schedule = useCallback(
    async (content: string, sourceType: string, sourceId: string, postAtISO: string) => {
      store.setPostAt(postAtISO)
      await run(action)
      onComplete?.([])
    },
    [action, run, store, onComplete],
  )

  return { schedule }
}
